$(function () {
  var $page = $('.sales-aggregations-page');
  if ($page.length === 0) return;

  var $form = $('#sales-aggregation-form');
  var $workerSelect = $('#sa_worker_ids');
  var $departmentSelect = $('#sa_department_id');
  var $workerField = $workerSelect.closest('.sa-field');
  var $orderedAtFrom = $('#sa_ordered_at_from');
  var $orderedAtTo = $('#sa_ordered_at_to');
  var $serverAlert = $('#sa-server-alert');
  var $accountingClassificationInputs = $page.find('input[name="accounting_classification"]');
  var loadWorkersUrl = '/sales_aggregations/load_worker_options';
  var allDepartmentOptions = $departmentSelect.data('all-options') || [];
  var individualDepartmentOptions = $departmentSelect.data('individual-options') || [];

  if (!$.fn.select2) return;

  function currentOutputUnit() {
    return $page.find('input[name="output_unit"]:checked').val();
  }

  function parseYmd(value) {
    if (!value) return null;
    var match = String(value).match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
    if (!match) return null;

    var year = Number(match[1]);
    var monthIndex = Number(match[2]) - 1;
    var day = Number(match[3]);
    var date = new Date(year, monthIndex, day);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== monthIndex ||
      date.getDate() !== day
    ) {
      return null;
    }

    return date;
  }

  function hideResolvedDateRangeAlert() {
    if ($serverAlert.length === 0 || !$serverAlert.is(':visible')) return;

    var alertText = String($serverAlert.data('alert-text') || $serverAlert.text() || '');
    if (alertText.indexOf('期間（開始日・終了日）の指定が不正です。') === -1) return;

    var fromDate = parseYmd($orderedAtFrom.val());
    var toDate = parseYmd($orderedAtTo.val());
    if (!fromDate || !toDate || fromDate > toDate) return;

    $serverAlert.stop(true, true).slideUp(150, function () {
      $(this).remove();
    });
  }

  function initSingleSelect($select) {
    if ($select.hasClass('select2-hidden-accessible')) {
      $select.select2('destroy');
    }

    $select.select2({
      width: '100%',
      theme: 'bootstrap',
      allowClear: false,
      language: { noResults: function () { return '見つかりません。'; } },
    });
  }

  function rebuildDepartmentSelect(options) {
    var currentValue = String($departmentSelect.val() || '');
    var html = (options || []).map(function (option) {
      var label = option[0];
      var value = String(option[1] == null ? '' : option[1]);
      var selected = value === currentValue ? ' selected' : '';
      return '<option value="' + value + '"' + selected + '>' + label + '</option>';
    }).join('');

    if ($departmentSelect.hasClass('select2-hidden-accessible')) {
      $departmentSelect.select2('destroy');
    }

    $departmentSelect.html(html);

    if (!$departmentSelect.find('option:selected').length) {
      $departmentSelect.val('');
    }

    initSingleSelect($departmentSelect);
  }

  function initWorkerSelect() {
    if ($workerSelect.hasClass('select2-hidden-accessible')) {
      $workerSelect.select2('destroy');
    }

    $workerSelect.select2({
      width: '100%',
      theme: 'bootstrap',
      multiple: true,
      placeholder: '選択してください',
      allowClear: true,
      closeOnSelect: false,
      language: { noResults: function () { return '見つかりません。'; } },
    });
  }

  initSingleSelect($departmentSelect);
  initWorkerSelect();

  function setWorkerEnabled(enabled) {
    var selectedValues = $workerSelect.val();
    if (!enabled) {
      $workerSelect.val(null);
    } else if (selectedValues && selectedValues.length > 0) {
      $workerSelect.val(selectedValues);
    }

    $workerSelect.trigger('change.select2');
    $workerField.toggleClass('is-disabled', !enabled);
  }

  function syncOutputUnitUi() {
    var unit = currentOutputUnit();
    rebuildDepartmentSelect(unit === 'individual' ? individualDepartmentOptions : allDepartmentOptions);
    setWorkerEnabled(unit === 'individual');
  }

  function refreshOutputUnitState(options) {
    var selectedIds = (options && options.selectedIds) || [];
    var shouldReloadWorkers = !options || options.reloadWorkers !== false;

    syncOutputUnitUi();

    if (!shouldReloadWorkers) return;

    if (currentOutputUnit() === 'individual') {
      loadWorkerOptions($departmentSelect.val(), selectedIds);
    } else {
      loadWorkerOptions('', []);
    }
  }

  function rebuildWorkerSelect(workers, selectedIds) {
    var options = [];
    var unit = currentOutputUnit();
    var normalizedSelectedIds = (selectedIds || []).map(function (value) { return String(value); });

    if (unit !== 'individual') {
      options.push('<option value="">すべて</option>');
    }

    (workers || []).forEach(function (worker) {
      var selected = normalizedSelectedIds.indexOf(String(worker.id)) >= 0 ? ' selected' : '';
      options.push(
        '<option value="' + worker.id + '"' + selected + '>' + worker.fullname + '</option>'
      );
    });

    var wasDisabled = $workerSelect.prop('disabled');
    if ($workerSelect.hasClass('select2-hidden-accessible')) {
      $workerSelect.select2('destroy');
    }
    $workerSelect.html(options.join(''));
    initWorkerSelect();
    $workerField.toggleClass('is-disabled', currentOutputUnit() !== 'individual');
  }

  function loadWorkerOptions(departmentId, selectedIds) {
    if (currentOutputUnit() === 'individual' && !departmentId) {
      rebuildWorkerSelect([], selectedIds || []);
      return;
    }

    $.ajax({
      url: loadWorkersUrl,
      method: 'GET',
      data: { department_id: departmentId || '' },
      success: function (res) {
        rebuildWorkerSelect(res.workers || [], selectedIds || []);
      }
    });
  }

  $departmentSelect.on('change', function () {
    loadWorkerOptions($(this).val(), []);
  });

  $workerSelect.on('select2:opening', function (event) {
    if (currentOutputUnit() !== 'individual') {
      event.preventDefault();
    }
  });

  $page.on('change', 'input[name="output_unit"]', function () {
    refreshOutputUnitState({ reloadWorkers: true });
  });
  refreshOutputUnitState({ reloadWorkers: false });

  function initSingleDatePicker($input) {
    if (!$input.length || $input.data('daterangepicker')) return;

    $input.daterangepicker({
      locale: ja_date_locale,
      autoUpdateInput: false,
      autoApply: true,
      singleDatePicker: true,
      showDropdowns: true,
    });

    $input.on('apply.daterangepicker', function (_ev, picker) {
      $(this).val(picker.startDate.format('YYYY/MM/DD'));
      $(this).closest('.input-clearable').find('.clear-icon').show();
      $(this).trigger('change');
      hideResolvedDateRangeAlert();
    });

    $input.on('cancel.daterangepicker', function () {
      $(this).val('');
      $(this).closest('.input-clearable').find('.clear-icon').hide();
      $(this).trigger('change');
    });
  }

  initSingleDatePicker($orderedAtFrom);
  initSingleDatePicker($orderedAtTo);

  $page.on('click', '.input-clearable .clear-icon', function () {
    var $input = $(this).siblings('input');
    $input.val('');
    $(this).hide();
    $input.trigger('change');
  });

  $orderedAtFrom.on('change', hideResolvedDateRangeAlert);
  $orderedAtTo.on('change', hideResolvedDateRangeAlert);
  hideResolvedDateRangeAlert();

  $('#sa-clear-btn').on('click', function () {
    $page.find('input[name="output_unit"][value="all"]').prop('checked', true);
    $page.find('input[name="accounting_classification"][value="ordered"]').prop('checked', true);
    $orderedAtFrom.val('');
    $orderedAtTo.val('');
    $page.find('.input-clearable .clear-icon').hide();
    $departmentSelect.val('').trigger('change.select2');
    $page.find('.sa-sales-type-checkbox').prop('checked', true);
    loadWorkerOptions('', []);
    syncOutputUnitUi();
  });

  $form.on('submit', function (event) {
    var unit = currentOutputUnit();
    var accountingClassification = ($accountingClassificationInputs.filter(':checked').val() || 'ordered');
    var messages = [];
    var hasSalesType = $page.find('.sa-sales-type-checkbox:checked').length > 0;

    if (!$orderedAtFrom.val() || !$orderedAtTo.val()) {
      messages.push('期間を指定してください。');
    }
    if (!hasSalesType) {
      messages.push('売上種別を1つ以上選択してください。');
    }
    if (unit === 'individual') {
      if (!$departmentSelect.val()) {
        messages.push('個別出力では部署を選択してください。');
      }
      if (($workerSelect.val() || []).length === 0) {
        messages.push('個別出力では担当者を1人以上選択してください。');
      }
    }

    if (messages.length > 0) {
      event.preventDefault();
      window.alert(messages.join('\n'));
      return;
    }

    if (accountingClassification === 'sales') {
      event.preventDefault();
      window.alert('売上基準の出力はまだ未対応です。受注を選択してください。');
    }
  });
});
